import { BrandProtectedComponent } from '@components'

import { ModuleLayout, withModalConditionalRender } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

import { EInvoicingSetupContextProvider } from '@features/eInvoicing/context/EInvoicingSetupContext'
import { EInvoicingDashboardBanner } from '@features/eInvoicing/elements/EinvoicingDashboardBanner'
import { EInvoicingDeactivatedBanner } from '@features/eInvoicing/elements/EInvoicingDeactivatedBanner'
import { ExternalInvoicesSyncDashboardBanner } from '@features/externalInvoicesSync'
import { ConnectionRenewedModal } from '@features/openBanking/elements/BankIntegrationModals/elements/SuccessfulConnectionModal'

import { ModalId } from '../../../../enums/modalId'
import { useSynchronizeWidgets } from '../../hooks/useSynchronizeWidgets'
import { AnnualReports } from '../Banners/AnnualReports'
import { DashboardActions } from '../DashboardActions'
import { DashboardSkeleton } from '../DashboardSkeleton'
import { DashboardWidgetsEditAction } from '../DashboardWidgetsEditAction'
import { Widgets } from '../Widgets'
import { useDashboardLoadMetrics } from './hooks/useDashboardLoadMetrics'

const BankConnectionRenewedModal = withModalConditionalRender(ConnectionRenewedModal)

export const DashboardLayout = () => {
  const { t } = useTranslation()

  const { isFetchingOrganizationSettings } = useSynchronizeWidgets()

  useDashboardLoadMetrics({
    isFetchingOrganizationSettings,
  })

  return (
    <ModuleLayout
      title={t('dashboard')}
      sideActions={<DashboardActions />}
      headerContent={<DashboardWidgetsEditAction />}
    >
      {isFetchingOrganizationSettings ? (
        <DashboardSkeleton />
      ) : (
        <>
          <AnnualReports />
          <BrandProtectedComponent brand="ageras">
            <ExternalInvoicesSyncDashboardBanner />
          </BrandProtectedComponent>
          <EInvoicingSetupContextProvider>
            <EInvoicingDashboardBanner source="dashboard" />
            <EInvoicingDeactivatedBanner isCloseable={true} includePadding={true} />
          </EInvoicingSetupContextProvider>
          <Widgets />
          <BankConnectionRenewedModal id={ModalId.BankConnectionSuccessModal} />
        </>
      )}
    </ModuleLayout>
  )
}
